// @ts-check
/**
 * @file quietHours.js
 * @location src/utils/quietHours.js
 * @role 방해금지 시간 판정 — 한국 직장 정서 보호 가드(razor 운영 정책).
 *
 * 기본 정책(KST 기준, 사용자 토글 없음):
 *   · 평일(월~금) 22:00 ~ 익일 08:00 → 방해금지
 *   · 토·일 종일 → 방해금지
 *
 * SW(sw.js) push 핸들러에서 호출 — 페이로드의 `urgent: true` 가 우선해 우회 가능(예: 시스템 공지).
 * Intl.DateTimeFormat 으로 사용자 디바이스 시간대와 무관하게 KST 로 일관 판정.
 */

/** Intl.DateTimeFormat 의 weekday('short') 값 → 0(일)~6(토) */
const WEEKDAY_INDEX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

/**
 * 주어진 시각이 KST 기준 방해금지 시간대인지.
 * @param {Date} [now=new Date()]
 * @returns {boolean}
 */
export function isQuietHours(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Seoul',
    weekday: 'short',
    hour: 'numeric',
    hour12: false,
  }).formatToParts(now);

  const weekdayStr = parts.find(p => p.type === 'weekday')?.value ?? '';
  const hourStr = parts.find(p => p.type === 'hour')?.value ?? '';
  const day = WEEKDAY_INDEX[/** @type {keyof typeof WEEKDAY_INDEX} */ (weekdayStr)];
  // Intl 가 자정을 '24' 로 반환하는 경우(en-US hour12:false) 0 으로 정규화.
  const hour = Number(hourStr) % 24;

  // 토(6) · 일(0) 종일.
  if (day === 0 || day === 6) return true;
  // 평일 22:00 ~ 익일 08:00.
  return hour >= 22 || hour < 8;
}

/** 안내 카피 단일 소스 — UI 와 동의어 사이 표류 방지. */
export const QUIET_HOURS_LABEL = '평일 22:00~08:00, 주말 종일';
